export function* randomHSLCSS() {
  let index = 1;

  while (true) {
    const hueVariance = Math.floor(Math.random() * 36);
    const hue = index * 36 + hueVariance;
    const saturation = 70 + Math.floor(Math.random() * 30);
    const lightness = 40 + Math.floor(Math.random() * (saturation > 80 ? 30 : 40));

    yield `hsl(${hue}, ${saturation}%, ${lightness}%)`;

    index += 3;
    index = index % 10;
  }
}

export function stringToHSLCSS(value: string) {
  if (!value?.length) {
    return `hsl(256, 95.5%, 34.7%)`; // primary color
  }

  let stringSum = value?.length;

  // accumulate sum of chars for use later - max of 64 chars checked
  for (let i = 0; i < value?.length && i < 64; i++) {
    stringSum += value.charCodeAt(i) || 1;
  }

  const slVariance = stringSum % 15;

  stringSum = stringSum % 101;

  return `hsl(${Math.floor(137.5 * stringSum)}, ${45 + slVariance}%, ${50 + slVariance}%)`;
}
